
import { useEffect, useState } from 'react';
import InnerNavigation from './InnerNavigation';
import InnerFooter from './InnerFooter';

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white text-charcoal">
      <InnerNavigation scrolled={scrolled} />
      {children}
      <InnerFooter />
    </div>
  );
}
